import { taskManagementSliceSelector } from "../taskManagementSliceSelector";
import { RootState } from "../../../store";
import { Task } from "../../../../services/cloudchipr.api";

export const selectedTasksSelector = (state: RootState): Task[] => {
  const slice = taskManagementSliceSelector(state);

  return slice.list.selectedTasks;
};
